/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1SaleschannelsQueryResponse } from '../../types/GetV1Saleschannels.ts'

export const getV1SaleschannelsQueryKey = () => [{ url: '/v1/SalesChannels' }] as const

export type GetV1SaleschannelsQueryKey = ReturnType<typeof getV1SaleschannelsQueryKey>

/**
 * {@link /v1/SalesChannels}
 */
export async function getV1Saleschannels(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<GetV1SaleschannelsQueryResponse, ResponseErrorConfig<Error>, unknown>(
        { method: 'GET', url: `/v1/SalesChannels`, ...requestConfig },
    )
    return res
}

export function getV1SaleschannelsQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1SaleschannelsQueryKey()
    return queryOptions<
        ResponseConfig<GetV1SaleschannelsQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1SaleschannelsQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1Saleschannels(config)
        },
    })
}

/**
 * {@link /v1/SalesChannels}
 */
export function useGetV1Saleschannels<
    TData = ResponseConfig<GetV1SaleschannelsQueryResponse>,
    TQueryData = ResponseConfig<GetV1SaleschannelsQueryResponse>,
    TQueryKey extends QueryKey = GetV1SaleschannelsQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1SaleschannelsQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1SaleschannelsQueryKey()

    const query = useQuery(
        {
            ...getV1SaleschannelsQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
